/*
 * Module for response translation modal
 */

// noinspection JSUnusedLocalSymbols
define([
  "marionette",
  "jquery",
  "backbone",
  "messaging/messenger",
  "modules/reviewer/reviewerTranslationModal/reviewerTranslationModalView",
  "modules/shared/ckeditor5/ckEditor5Module",
], function (Marionnete, $, Backbone, Messenger, ReviewerTranslationModalView, Es6CkEditor5Module) {
  const CkEditor5Module = Es6CkEditor5Module.default || Es6CkEditor5Module;

  return Marionnete.Controller.extend({
    initialize: function (options) {
      this.region = options.region;
      this.name = "ReviewerTranslationModal";
      this._setUpVents();
    },
    show: function (conversationObject) {
      const conversationNode = conversationObject.node;
      const selectedTouchPoint = conversationObject.selectedTouchPoint;
      const sourceLanguageId = conversationObject.selectedLanguage;
      const targetLanguageId = conversationObject.targetLanguage;
      let sourceLangName = "";
      let targetLangName = "";
      const languages = Messenger.reqres.request("kb:languages");
      languages.onSynced(function () {
        for (let i = 0; i < languages.length; i++) {
          if (languages.models[i].get("id") === sourceLanguageId) {
            sourceLangName = languages.models[i].get("name");
          }
          if (languages.models[i].get("id") === targetLanguageId) {
            targetLangName = languages.models[i].get("name");
          }
        }
      }, this);
      const response = new Backbone.Model({
        sourceResponse: "",
        targetResponse: "",
        touchPointId: selectedTouchPoint,
        sourceLanguageId: sourceLanguageId,
        targetLanguageId: targetLanguageId,
        sourceLangName: sourceLangName,
        targetLangName: targetLangName,
      });
      const sourceResponse = conversationNode.findResponseTemplate(
        selectedTouchPoint,
        sourceLanguageId,
      );
      const targetResponse = conversationNode.findOrAddResponseTemplate(
        selectedTouchPoint,
        targetLanguageId,
      );
      response.set("sourceResponseId", sourceResponse ? sourceResponse.id : 0);
      response.set("targetResponseId", targetResponse ? targetResponse.id : 0);
      Messenger.reqres.request("kb:privileged:area:roles").onSynced(function () {
        const responseWithNames = conversationNode.addPrivilegedRoleNamesToResponse(
          sourceResponse ? sourceResponse.get("response") : "",
        );
        const targetResponseWithNames = conversationNode.addPrivilegedRoleNamesToResponse(
          targetResponse ? targetResponse.get("response") : "",
        );
        response.set("sourceResponse", responseWithNames);
        response.set("targetResponse", targetResponseWithNames);
      }, this);

      this.view = new ReviewerTranslationModalView.reviewerTranslationModalView({
        model: response,
      });
      this.view.on(
        "done",
        function () {
          //update the translation
          this._updateTranslation(conversationNode, selectedTouchPoint, targetLanguageId);
          //fire event that the node was selected in order to rerender the response preview
          Messenger.vent.trigger("selected:node", conversationNode);
          Messenger.vent.trigger("close:modal");
        },
        this,
      );
      this.view.on(
        "cancel",
        function () {
          // handle a cancel click
          //ignore any changes to the response
          Messenger.vent.trigger("close:modal");
        },
        this,
      );

      this.htmlEditor = this.addSubModule(
        new CkEditor5Module.ckEditor5Module({ namespace: this.name, region: this.view.htmlEditor }),
      );
      this.view.on("show", () => {
        this.htmlEditor.show({
          languageId: response.get("targetLanguageId"),
          touchPointId: response.get("touchPointId"),
          responseId: response.get("targetResponseId"),
          response: response.get("targetResponse"),
          allCategories: Messenger.reqres.request("kb:categories"),
          attributes: conversationNode.topicAttributes(),
          categories: conversationNode.categories(),
          skipCollaborationFeatures: true,
          skipOpenSnippetEditor: true,
        });
      });

      this.showRegion(this.view);
    },
    _setUpVents: function () {
      Messenger.vent.on(Messenger.getFullName("ckeditor:initializeError", this.name), () =>
        Messenger.vent.trigger("close:modal"),
      );
    },
    _updateTranslation: function (conversationNode, selectedTouchPoint, targetLanguageId) {
      // Only update if the CKEditor actually has changes.  Cannot just compare with what we currently have,
      // because the CKEditor does some modification of the HTML to "sanitize" it.
      if (this.htmlEditor.isDirty()) {
        //get the new response from the translation modal
        const newResponse = this.htmlEditor.getResponse();
        //update the conversationNode with the new response
        conversationNode.setResponse(selectedTouchPoint, targetLanguageId, newResponse);
        console.log("Translation updated!");
      }
    },
  });
});
